import { render, staticRenderFns } from "./SubscriptionRenewal.vue?vue&type=template&id=5672b414&scoped=true"
import script from "./SubscriptionRenewal.vue?vue&type=script&lang=js"
export * from "./SubscriptionRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672b414",
  null
  
)

export default component.exports